import { CSSProperties } from 'react'
import { Theme } from '../../token/theme'

export const getToastTypeColor = (type: string, theme: Theme) => {
    switch (type) {
        case 'SUCCESS':
            return {
                background: theme.color.background.successLightBg,
                color: theme.color.text.success,
                borderColor: theme.color.text.success
            }
        default:
        case 'ERROR':
            return {
                background: theme.color.background.warningLightBg,
                color: theme.color.text.warning,
                borderColor: theme.color.background.warning
            }
    }
}

export const getToastPosition = (position: string) => {
    switch (position) {
        case 'TOP':
            return {
                top: 0,
                bottom: 'auto',
                transform: (visible: boolean) =>
                    visible ? 'translateY(0)' : 'translateY(-100%)'
            }
        case 'BOTTOM':
        default:
            return {
                top: 'auto',
                bottom: 0,
                transform: (visible: boolean) =>
                    visible ? 'translateY(0)' : 'translateY(100%)'
            }
    }
}

export const getToastStyles = ({
    theme,
    type,
    position,
    visible
}: {
    theme: Theme
    type: string
    position: string
    visible: boolean
}) => {
    const typeStyles = getToastTypeColor(type, theme)
    const positionStyles = getToastPosition(position)

    return {
        containerStyle: {
            position: 'fixed',
            left: 0,
            right: 0,
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            top: positionStyles.top,
            bottom: positionStyles.bottom,
            transform: positionStyles.transform(visible),
            transition: 'transform 0.3s ease-in-out',
            pointerEvents: 'none' as const
        } as CSSProperties,

        toastStyle: {
            margin: '16px',
            pointerEvents: 'auto' as const,
            backgroundColor: typeStyles.background,
            borderRadius: '4px',
            borderLeft: `4px solid ${typeStyles.borderColor}`,
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
            padding: '12px 16px',
            maxWidth: '600px',
            width: '100%'
        } as CSSProperties,
        textColor: typeStyles.color
    }
}
